export default "__VITE_ASSET__BwDQ_OI4__"